import { AidPreferenceDtoToEntity } from "src/app/features/EmvKernelProfile/subFeatures/AidPreference/services/mappers/AidPreferenceDtoToEntity";
import type { AidPreferenceDto } from "src/app/features/EmvKernelProfile/subFeatures/AidPreference/types/AidPreferenceDto";
import type { AidPreferenceEntity } from "src/app/features/EmvKernelProfile/subFeatures/AidPreference/types/AidPreferenceEntity";
import type { ResourcePageDto } from "../../../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../../../core/types/fe/entities/ResourcePageEntity";

export const AidPreferenceTableDtoMapper = (
    input: Readonly<ResourcePageDto<AidPreferenceDto>>,
): ResourcePageEntity<AidPreferenceEntity> => {
    return {
        list: input.list ? input.list.map(AidPreferenceDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
